import {
  all,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import { APP_CONTROLLER_REDUCERS_ACTIONS } from '@bitComponents/unifiedComponents/AppController';
import { addParamsToSaga } from '@bitComponents/telcovid/ReduxSagaUtils';
import { normalizeHttpErrors } from '../errorManagement/errorNormalizer';
import { types as UINeedsTypes } from '../reducers/uiNeeds';
import { types as addressTypes } from '../reducers/address';
import { types as pinTypes } from '../reducers/pin';
import { commonTypes } from '../reducers/common';
import * as MegaMinderSagas from '../minder/MegaMinder';
import * as InitSagas from './init';
import * as GenesysSagas from './genesys';
import * as ResetSagas from './resetFlow';
import * as AddressSagas from './address';
import * as PinSagas from './pin';
import * as RegisterSagas from './register';
import * as OBDSagas from './obd';
import * as ClientActionsSagas from './clientActions';
import { minderSagas } from './minderSaga';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { types as obdTypes } from '../reducers/obd';

const { errorCatcherActions } = APP_CONTROLLER_REDUCERS_ACTIONS;

const { showInPageError: showError } = errorCatcherActions;

const dotPathToMinder = 'flow.minderJson';

export default function* rootSaga() {
  yield all([
    takeEvery('SET_CONTEXT_DATA', InitSagas.initializeFlow, { showError, normalizeHttpErrors }),
    takeEvery('@@router/LOCATION_CHANGE', InitSagas.checkCorrectNavigation),
    takeEvery(
      commonTypes.INITIALIZE_RESET_FLOW,
      addParamsToSaga(ResetSagas.resetFlow, { normalizeHttpErrors, showError }),
    ),
    takeEvery(
      commonTypes.SET_MAIN_ACTION_INFO,
      addParamsToSaga(ClientActionsSagas.setMainAction, { normalizeHttpErrors, showError }),
    ),
    takeEvery(
      commonTypes.SET_SECONDARY_ACTION_INFO,
      addParamsToSaga(ClientActionsSagas.setSecondaryAction, { normalizeHttpErrors, showError }),
    ),
    takeEvery(
      commonTypes.SET_MAIN_ACTION_ADDITIONAL_INFO,
      addParamsToSaga(ClientActionsSagas.setMainActionAdditionalInfo, { normalizeHttpErrors, showError }),
    ),
    takeEvery(
      commonTypes.SET_SECONDARY_ACTION_ADDITIONAL_INFO,
      addParamsToSaga(ClientActionsSagas.setSecondaryActionAdditionalInfo, { normalizeHttpErrors, showError }),
    ),
    takeEvery(obdTypes.GENERATE_PIN,
      addParamsToSaga(OBDSagas.generateOBDPin,
        {
          showError,
          normalizeHttpErrors,
        })),
    takeEvery(obdTypes.VALIDATE_PIN,
      addParamsToSaga(OBDSagas.validateOBDPin,
        {
          showError,
          normalizeHttpErrors,
        })),
    takeEvery(commonTypes.SET_CONFIRMED_STEP,
      addParamsToSaga(MegaMinderSagas.executeApisToAdvance,
        {
          showError,
          normalizeHttpErrors,
          dotPathToMinder,
          minderSagas,
          loaderControlActions,
        })),
    takeLatest(addressTypes.GET_HORIZONTAL_ADDRESSES,
      addParamsToSaga(AddressSagas.getHorizontalAddresses,
        { normalizeHttpErrors, showError })),
    takeLatest(addressTypes.GET_VERTICAL_ADDRESSES,
      addParamsToSaga(AddressSagas.getVerticalAddresses,
        { normalizeHttpErrors, showError })),
    takeLatest(commonTypes.SET_ADDRESS_INFO,
      addParamsToSaga(AddressSagas.getShippingAddressById,
        { normalizeHttpErrors, showError })),
    takeLatest(commonTypes.SET_PERMANENT_RESIDENCE_INFO,
      addParamsToSaga(AddressSagas.getPermanentResidenceAddressById,
        { normalizeHttpErrors, showError })),
    takeLatest(commonTypes.SET_INSTALLATION_ADDRESS,
      addParamsToSaga(AddressSagas.getInstallationAddressById,
        { normalizeHttpErrors, showError })),
    takeLatest(
      pinTypes.GET_VALIDATION_PIN_BEGINS,
      addParamsToSaga(PinSagas.getPin, { normalizeHttpErrors, showError }),
    ),
    takeLatest(
      UINeedsTypes.SEND_RISK_TO_GENESYS,
      addParamsToSaga(GenesysSagas.sendRiskToGenesys, { normalizeHttpErrors, showError }),
    ),
    takeLatest(
      pinTypes.VALIDATE_VALIDATION_PIN_BEGINS,
      addParamsToSaga(PinSagas.validatePin, { normalizeHttpErrors, showError }),
    ),
    takeEvery(
      commonTypes.REGISTER_SHOPPER,
      addParamsToSaga(RegisterSagas.registerShopper, { normalizeHttpErrors, showError }),
    ),
    takeEvery(
      commonTypes.VALIDATE_SHOPPER,
      addParamsToSaga(RegisterSagas.validateShopper, { normalizeHttpErrors, showError }),
    ),
  ]);
}
